//general
import React, { useContext } from "react";
//Styles
import { Modal } from "react-bootstrap";
import { Formik, Form } from "formik";
import { TextField, MenuItem, Autocomplete } from "@mui/material";
//Context
import { SuppliersContext } from "../../data/suppliers/SuppliersContext";
import { useValidations } from "../../data/ValidationContext";
import { DealersContext } from "../../data/dealers/DealersContex";

const SuppliersUpdateModal = ({ isOpen, onClose, supplierId }) => {
    const { suppliersList, updateSupplier } = useContext(SuppliersContext);
    const { dealersList } = useContext(DealersContext);
    const { vs_supplier } = useValidations();

    const supplier = suppliersList.find((s) => s.id === supplierId);
    if (!supplier) return null;

    const initialValues = {
        supplierName: supplier.supplierName,
        dealerName: supplier.dealerName,
        status: supplier.status,
    };
//HTML
    return (
        <Modal show={isOpen} onHide={onClose} centered>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={vs_supplier}
                onSubmit={(values) => {
                    updateSupplier(supplierId, values);
                    onClose();
                }}
            >
                {({ values, errors, touched, handleChange, setFieldValue }) => (
                    <Form>
                        <Modal.Header closeButton>
                            <Modal.Title>Tedarikçi Güncelle</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            {/* Tedarikçi Adı */}
                            <div className="mb-3">
                                <TextField
                                    label="Tedarikçi Adı"
                                    name="supplierName"
                                    value={values.supplierName}
                                    onChange={handleChange}
                                    fullWidth
                                    size="small"
                                    error={touched.supplierName && !!errors.supplierName}
                                    helperText={touched.supplierName && errors.supplierName}
                                />
                            </div>

                            {/* Bayi Adı - Autocomplete */}
                            <div className="mb-3">
                                <Autocomplete
                                    options={dealersList.map((d) => d.name)}
                                    value={values.dealerName || null}
                                    onChange={(_, newValue) => setFieldValue("dealerName", newValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Bayi Adı"
                                            size="small"
                                            error={touched.dealerName && !!errors.dealerName}
                                            helperText={touched.dealerName && errors.dealerName}
                                        />
                                    )}
                                />
                            </div>

                            {/* Durum */}
                            <div>
                                <TextField
                                    select
                                    label="Durum"
                                    name="status"
                                    value={values.status}
                                    onChange={handleChange}
                                    fullWidth
                                    size="small"
                                    error={touched.status && !!errors.status}
                                    helperText={touched.status && errors.status}
                                >
                                    <MenuItem value="Aktif">Aktif</MenuItem>
                                    <MenuItem value="Pasif">Pasif</MenuItem>
                                </TextField>
                            </div>
                        </Modal.Body>

                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary" onClick={onClose}>
                                İptal
                            </button>
                            <button type="submit" className="btn btn-primary">
                                Güncelle
                            </button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default SuppliersUpdateModal;
